<script lang="ts">
  import type { Snippet } from 'svelte'
  import Layout from './Layout.svelte'
  import Meta from './Meta.svelte'
  import PageContainer from './PageContainer.svelte'

  let {
    title,
    description,
    lastUpdated,
    children,
  }: {
    title: string
    description: string
    lastUpdated: string
    children: Snippet
  } = $props()
</script>

<Meta />

<Layout showWhatsNewBanner={false}>
  <PageContainer maxWidth="max-w-4xl" paddingY="py-10 sm:py-14">
    <article
      class="overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
    >
      <header
        class="border-b border-neutral-200 bg-primary-50 px-6 py-8 dark:border-gray-700 dark:bg-gray-900 sm:px-10 sm:py-10"
      >
        <p
          class="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600 dark:text-primary-300"
        >
          Reading Now
        </p>
        <h1
          class="font-bookshop text-4xl tracking-tight text-neutral-900 dark:text-white sm:text-5xl"
        >
          {title}
        </h1>
        <p class="mt-4 max-w-2xl leading-7 text-neutral-600 dark:text-gray-300">
          {description}
        </p>
        <p class="mt-4 text-sm text-neutral-500 dark:text-gray-400">
          Last updated {lastUpdated}
        </p>
      </header>

      <div class="legal-content px-6 py-8 sm:px-10 sm:py-10">
        {@render children()}
      </div>
    </article>
  </PageContainer>
</Layout>

<style>
  :global(.legal-content section + section) {
    margin-top: 2.25rem;
    padding-top: 2.25rem;
    border-top: 1px solid var(--color-neutral-200);
  }
  :global(.dark .legal-content section + section) {
    border-color: var(--color-gray-700);
  }
  :global(.legal-content h2) {
    color: var(--color-neutral-900);
    font-family: var(--font-bookshop);
    font-size: 1.625rem;
    letter-spacing: -0.02em;
    line-height: 1.25;
  }
  :global(.dark .legal-content h2) {
    color: white;
  }
  :global(.legal-content h3) {
    margin-top: 1.5rem;
    color: var(--color-neutral-800);
    font-size: 1rem;
    font-weight: 650;
  }
  :global(.dark .legal-content h3) {
    color: var(--color-gray-100);
  }
  :global(.legal-content p),
  :global(.legal-content li) {
    color: var(--color-neutral-600);
    font-size: 0.9375rem;
    line-height: 1.8;
  }
  :global(.dark .legal-content p),
  :global(.dark .legal-content li) {
    color: var(--color-gray-300);
  }
  :global(.legal-content p) {
    margin-top: 1rem;
  }
  :global(.legal-content ul) {
    margin-top: 1rem;
    list-style: disc;
    padding-left: 1.4rem;
  }
  :global(.legal-content li + li) {
    margin-top: 0.55rem;
  }
  :global(.legal-content a) {
    color: var(--color-primary-600);
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 0.2em;
  }
  :global(.dark .legal-content a) {
    color: var(--color-primary-300);
  }
</style>
